import React, { useState } from 'react';
import { Button, Dialog, Slide, AppBar, Toolbar, IconButton, Typography, List, ListItem, ListItemText, Divider } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import {ThemeClient} from '../../contexts/Theme';
import Navbar from '../../Navbar';
import Container from '@mui/material/Container';
import Question from '../../components/session/activities/Question';
import SendQuiz from '../../components/session/activities/SendQuiz';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function Quiz({ openQuiz, setOpenQuiz, setQuiz, activity, setCongratulations }) {

    let quiz = [
        {
            question: '¿Qué te inspira a alcanzar tus metas?',
            alternatives: ['La pasión por lo que hago', 'El deseo de superarme', 'El apoyo de mis seres queridos', 'Busco nuevas formas de abordar el problema.']
        },
        {
            question: '¿Cómo te mantienes motivado/a cuando enfrentas desafíos?',
            alternatives: ['Busco apoyo en mi red de contactos', 'Me enfoco en mi visión y objetivos', 'Busco nuevas formas de abordar el problema', 'El apoyo de mis seres queridos']
        },
        {
            question: '¿Cuál es tu estrategia para superar el miedo al fracaso?',
            alternatives: ['Acepto que el fracaso es parte del proceso', 'Me enfoco en mis fortalezas y logros pasados', 'Busco modelos a seguir y aprendo de ellos', 'El apoyo de mis seres queridos']
        },
    ]; // DEMO

    if (activity){
        quiz = JSON.parse(activity.metadata).quiz
    }

    const [selectedOptions, setSelectedOptions] = useState();

    const handleOptionChange = () => {
        //setSelectedOptions( optionId );
    };

    const handleClickOpen = () => {
        setOpenQuiz(true);
    };

    const handleClose = () => {
        setOpenQuiz(false);
    };

    return (
        <ThemeClient>
            <Dialog fullScreen open={openQuiz} onClose={handleClose} TransitionComponent={Transition}>
                <Navbar title={'Quiz'} />
                <Container component="main" sx={{ marginTop: 2 }}>

                    {quiz.map((question, index) => (
                        <Question
                            key={index}
                            question={question}
                            options={question.alternatives}
                            selectedOptions={selectedOptions}
                            handleOptionChange={handleOptionChange}
                        />
                    ))}
                    <SendQuiz activity={activity} selectedOptions={selectedOptions} setOpenQuiz={setOpenQuiz} setQuiz={setQuiz} setCongratulations={setCongratulations} />
                </Container>

            </Dialog>
        </ThemeClient>
    );
}